import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import swal from 'sweetalert'
import DatePicker from 'react-datetime';
import moment from 'moment';
import ls from 'local-storage'
import 'react-datetime/css/react-datetime.css';

export class Invitingtenders extends Component {
    constructor(props){     
        super(props);
        this.state = {
            errors: {},
            agencylist:[],
            appstatuslist:[],
            partworkdtpmaster:[],
            age_excess_allowd:[],
            invitiongtenderslist:[],
            submitinvitiongtenderslist:[],
            masterinvitiongtenderslist:[],
            formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode},
                       
        };
        this.hideComponent = this.hideComponent.bind(this);
        this.selecthandleChange = this.selecthandleChange.bind(this);
        this.datepickerhandleChange = this.datepickerhandleChange.bind(this);
      }    
      componentDidMount() {
        document.title = "Inviting Tenders"
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        this.getdataafterload();
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;     
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/getappstatus`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.aastatuscd,
              "label" : d.aastatusdesc           
            }))    
            this.setState({appstatuslist: options})  
          }           
        });  
        Axios.get(`${process.env.REACT_APP_API_URL}master/getagency`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.agencyid,
              "label" : d.agencyname           
            }))    
            this.setState({agencylist: options})  
          }           
        });     
        Axios.post(`${process.env.REACT_APP_API_URL}master/getinvitiongtenders`, this.props.children)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
                "value" : d.tenderid,
                "label" : d.tendernoticeno           
              }))    
              this.setState({masterinvitiongtenderslist: options}) 
          }           
        });                   
      } 
      async getdataafterload()
      {
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;           
        Axios.post(`${process.env.REACT_APP_API_URL}partworks/invitingtenders`, this.props.children)
        .then(result=>{
          if(result.status === 200){
            this.setState({partworkdtpmaster:result.data.partworkdtpmaster,age_excess_allowd:result.data.age_excess_allowd,invitiongtenderslist:result.data.invitiongtenderslist,submitinvitiongtenderslist:result.data.submitinvitiongtenderslist});                                                  
          }      
        }); 
      }         
      hideComponent(e) { 
        let formdetails = this.state.formdetails;
        formdetails[e.target.name] = e.target.value;  
        this.setState({formdetails});
     }     
     handleValidation(name){
        let formdetails = this.state.formdetails;        
        let errors = {};
        let formIsValid = true;
        if(name === 'inviting'){
        if(!formdetails["dtpid"]){
            formIsValid = false;
            errors["dtpid"] = "Select DTP No";
          }
          if(!formdetails["tendnotice"]){
            formIsValid = false;
            errors["tendnotice"] = "Enter Tender Notice No";
          }
          if(!formdetails["tenddate"]){
            formIsValid = false;
            errors["tenddate"] = "Enter Date of Notice Inviting Tender";
          }
          if(!formdetails["techbiddate"]){
            formIsValid = false;
            errors["techbiddate"] = "Enter Date of opening of Technical bid";
          }
          if(!formdetails["pricebiddate"]){
            formIsValid = false;
            errors["pricebiddate"] = "Enter Date of Opening of Price Bid";
          }
          if(!formdetails["age_excess_allowd"]){
            formIsValid = false;
            errors["age_excess_allowd"] = "Select How Much Percentage Excess allowed for same rate of an item";
          }
          }
          if(name === 'submit'){
            if(!formdetails["tenderid"]){
                formIsValid = false;
                errors["tenderid"] = "Select Tender Notice No";
              }
              if(!formdetails["qualifiedagencies"]){
                formIsValid = false;
                errors["qualifiedagencies"] = "Enter No. of Agencies PreQualified";
              }
              if(!formdetails["totalagencies"]){
                formIsValid = false;
                errors["totalagencies"] = "Enter No. of Agencies for Bid";
              }
              if(!formdetails["bidvaliditydate"]){
                formIsValid = false;
                errors["bidvaliditydate"] = "Enter Bid Validity Date";
              }
              if(!formdetails["tendforwarddate"]){
                formIsValid = false;
                errors["tendforwarddate"] = "Enter Date of Forwarding";
              }
              if(!formdetails["tendforwarded"]){
                formIsValid = false;
                errors["tendforwarded"] = "Select Approved By";
              }
              if(!formdetails["proposedagencyid"]){
                formIsValid = false;
                errors["proposedagencyid"] = "Select Name of Agency Proposed for Approval";
              }
              }          
          this.setState({errors: errors});
          return formIsValid;                 
     }    
     async refreshvalue(){ 
        this.setState({formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode}}); 
      }
      contactSubmit(name,e){
        e.preventDefault();        
        if(this.handleValidation(name)){    
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL, 
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;         
          const data = this.state.formdetails;
          var path = '';
          if(name === 'inviting'){
             path = 'partworks/saveinvition_tenderts';
          }
          if(name === 'submit'){
             path = 'partworks/savesubmitinvition_tenderts'; 
          }
          Axios.post(`${process.env.REACT_APP_API_URL}`+path, data) 
            .then((responce) => {  
              const result = responce.data;
              if(result.status === 1){    
                this.getdataafterload();    
                this.refreshvalue();    
                swal({
                  title: result.msg,
                  text: "Data Save Successfully",
                  icon: "success",
                  buttons: true
                })             
            }
            else{
              if(result.status === 401){
              swal("Error", result.message, "error"); 
              }else{
                swal("Error", result.msg, "error"); 
              }              
            }              
            });
        }   
      }

      async selecthandleChange(name,e) {
        let formdetails = this.state.formdetails; 
        formdetails[name] = e.value;  
        this.setState({formdetails});        
      }  
      datepickerhandleChange(name,e){
        let formdetails = this.state.formdetails;
        formdetails[name] = e.format('DD-MM-YYYY');
        this.setState({formdetails});
      }    
      async InvitingTendersDeleted(tenderid,id){    
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;          
          const formdetails =  this.state.formdetails;
          formdetails['tenderid'] = tenderid;
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/deletetsforwaredtable`, formdetails) 
            .then((responce) => { 
              const status = responce.status;
              const result = responce.data;
              if(status === 200 ){
                this.getdataafterload();    
              if(result.status === 1){
                swal({
                  title: result.msg,
                  text: "DTP Forwared Delete Suceessfully",
                  icon: "success",
                  buttons: true
                }) 
            }
            else{
              swal("Error", result.msg || '', "error");               
            } 
          }             
        });          
      }             
    render() {
        const today = moment();
        const disableFutureDt = current => {
          return current.isBefore(today)
        }
        return (
                <div className="box">
                    <div className="box-body">
                        <div className="box-header">
                            <h3 className="box-title">Inviting Tenders</h3>
                        </div>
                        <div className="box-body">
                            <form onSubmit= {this.contactSubmit.bind(this,'inviting')}>
                            <div className="col-md-12" >
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                       <label className="control-label">DTP No.</label>
                                        <Select 
                                                options={this.state.partworkdtpmaster} 
                                                name="dtpid" 
                                                value={this.state.partworkdtpmaster.filter(({value}) => value === this.state.formdetails.dtpid)  || ''} 
                                                isClearable
                                                onChange={this.selecthandleChange.bind(this,'dtpid')} 
                                        />                    
                                        <span className="text-red">{this.state.errors["dtpid"]}</span>  
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Tender Notice No.</label>
                                        <input type="text" name="tendnotice" className="form-control" value={this.state.formdetails.tendnotice  || ''} onChange={this.hideComponent} />
                                        <span className="text-red">{this.state.errors["tendnotice"]}</span>
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Tender ID (nCode).</label>
                                        <input type="text" name="tender_id"  className="form-control" value={this.state.formdetails.tender_id  || ''} onChange={this.hideComponent} />
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-12" >
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Date of Notice Inviting Tender </label>
                                        <DatePicker 
                                            timeFormat={false}
                                            onChange={this.datepickerhandleChange.bind(this,'tenddate')}
                                            dateFormat="DD-MM-YYYY" 
                                            defaultValue={this.state.formdetails.tenddate || ''}
                                            closeOnSelect 
                                            isValidDate={disableFutureDt}
                                            inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                        />
                                        <span className="text-red">{this.state.errors["tenddate"]}</span>
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Date of opening of Technical bid</label>
                                        <DatePicker 
                                            timeFormat={false}
                                            onChange={this.datepickerhandleChange.bind(this,'techbiddate')}
                                            dateFormat="DD-MM-YYYY" 
                                            defaultValue={this.state.formdetails.techbiddate || ''}
                                            closeOnSelect 
                                            isValidDate={disableFutureDt}
                                            inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                        />
                                        <span className="text-red">{this.state.errors["techbiddate"]}</span>  
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Date of Opening of Price Bid</label>
                                        <DatePicker 
                                            timeFormat={false}
                                            onChange={this.datepickerhandleChange.bind(this,'pricebiddate')}
                                            dateFormat="DD-MM-YYYY" 
                                            defaultValue={this.state.formdetails.pricebiddate || ''}
                                            closeOnSelect 
                                            isValidDate={disableFutureDt}
                                            inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                        />
                                        <span className="text-red">{this.state.errors["pricebiddate"]}</span>     
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-12" >
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Date of Pre-Bid</label>
                                        <DatePicker 
                                            timeFormat={false}
                                            onChange={this.datepickerhandleChange.bind(this,'prebid')}
                                            dateFormat="DD-MM-YYYY" 
                                            defaultValue={this.state.formdetails.prebid || ''}
                                            closeOnSelect 
                                            isValidDate={disableFutureDt}
                                            inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                        />  
                                    </div>
                                </div>
                                <div className="col-md-8" >
                                    <div className="form-group required">
                                        <label className="control-label">How Much Percentage Excess allowed for same rate of an item</label>
                                        <Select 
                                                options={this.state.age_excess_allowd} 
                                                name="age_excess_allowd" 
                                                value={this.state.age_excess_allowd.filter(({value}) => value === this.state.formdetails.age_excess_allowd)  || ''} 
                                                isClearable
                                                onChange={this.selecthandleChange.bind(this,'age_excess_allowd')} 
                                        />                    
                                        <span className="text-red">{this.state.errors["age_excess_allowd"]}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" >
                                <div className="col-md-6" >
                                    <input type="submit" className="btn btn-primary" value="Save" />
                                </div>
                            </div>
                            </form>
                            <div className="col-md-12" >
                            <h5>Note: - Tender ID (nCode) અને Date of Pre-Bid લાગુ ન પડતુ હોય તો ખાલી રાખવુ.</h5>
                            </div>
                            <div className="col-md-12 table-responsive" >
                            <table className="table table-bordered" id="invitiongtenderslist">
                                <thead>
                                    <tr className="bg-gray">
                                        <th>Tender Notice No.</th>
                                        <th>Date of Notice Inviting Tender</th>
                                        <th>Date of Opening of Technical Bid</th>
                                        <th>Date of Opening of Price Bid</th>
                                        <th>Edit</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.invitiongtenderslist.map((value, index) => {
                                    return (
                                        <tr key={value.tenderid}>
                                            <td>{value.tendernoticeno}</td>
                                            <td>{value.tenderdate}</td>
                                            <td>{value.techdateofopeningofbid}</td>
                                            <td>{value.dateofopeningofbid}</td>
                                            <td><button onClick={this.InvitingTendersDeleted.bind(this,value.tenderid)} className="btn btn-primary btn-sm"><i className="fa fa-edit"></i></button></td>
                                            <td><button onClick={this.InvitingTendersDeleted.bind(this,value.tenderid)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                        </tr>
                                    )
                                })} 
                                </tbody>                                 
                            </table>
                            </div>
                        </div>
                        <div className="box-header">
                            <h3 className="text-center">Submission of Tender For Approval</h3>
                        </div>
                        <div className="box-body">
                            <form onSubmit= {this.contactSubmit.bind(this,'submit')}>
                            <div className="col-md-12" >
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Tender Notice No.</label>
                                        <Select 
                                                options={this.state.masterinvitiongtenderslist} 
                                                name="dtpid" 
                                                value={this.state.masterinvitiongtenderslist.filter(({value}) => value === this.state.formdetails.tenderid)  || ''} 
                                                isClearable
                                                onChange={this.selecthandleChange.bind(this,'tenderid')} 
                                        /> 
                                        <span className="text-red">{this.state.errors["tenderid"]}</span>                                       
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">No. of Agencies PreQualified</label>
                                        <input type="text" name="qualifiedagencies" className="form-control" value={this.state.formdetails.qualifiedagencies  || ''} onChange={this.hideComponent} />
                                        <span className="text-red">{this.state.errors["qualifiedagencies"]}</span>   
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">No. of Agencies for Bid</label>
                                        <input type="text" name="totalagencies" value={this.state.formdetails.totalagencies  || ''} onChange={this.hideComponent} className="form-control" />
                                        <span className="text-red">{this.state.errors["totalagencies"]}</span>
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-12" >
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Bid Validity Date</label>
                                        <DatePicker 
                                        timeFormat={false}
                                        onChange={this.datepickerhandleChange.bind(this,'bidvaliditydate')}
                                        dateFormat="DD-MM-YYYY" 
                                        value={this.state.formdetails.bidvaliditydate || ''}
                                        closeOnSelect 
                                        isValidDate={disableFutureDt}
                                        inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                    />
                                    <span className="text-red">{this.state.errors["bidvaliditydate"]}</span>    
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Date of Forwarding</label>
                                        <DatePicker 
                                            timeFormat={false}
                                            onChange={this.datepickerhandleChange.bind(this,'tendforwarddate')}
                                            dateFormat="DD-MM-YYYY" 
                                            selected={this.state.formdetails.tendforwarddate || ''}
                                            closeOnSelect 
                                            isValidDate={disableFutureDt}
                                            inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                        />
                                        <span className="text-red">{this.state.errors["tendforwarddate"]}</span>  
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Approved By</label>
                                        <Select 
                                                    options={this.state.appstatuslist} 
                                                    name="tendforwarded" 
                                                    value={this.state.appstatuslist.filter(({value}) => value === this.state.formdetails.tendforwarded)  || ''} 
                                                    isClearable
                                                    onChange={this.selecthandleChange.bind(this,'tendforwarded')} 
                                            /> 	
                                            <span className="text-red">{this.state.errors["tendforwarded"]}</span> 
                                    </div>
                                </div>
                                </div>
                                <div className="col-md-12" >
                                <div className="col-md-4" >
                                    <div className="form-group required">
                                        <label className="control-label">Name of Agency Proposed for Approval</label>
                                        <Select 
                                                options={this.state.agencylist} 
                                                name="proposedagencyid" 
                                                value={this.state.agencylist.filter(({value}) => value === this.state.formdetails.proposedagencyid)  || ''} 
                                                isClearable
                                                onChange={this.selecthandleChange.bind(this,'proposedagencyid')} 
                                        />                    
                                        <span className="text-red">{this.state.errors["proposedagencyid"]}</span>  
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Remarks</label>
                                        <textarea name="tendfremarks" className="form-control" value={this.state.formdetails.tendfremarks  || ''} onChange={this.hideComponent} />
                                    </div>
                                </div>
                                <div className="col-md-4" >
                                    <div className="form-group">
                                        <label>Upload PDF</label>
                                        <input type="file" className="custom-file-input" name="apppdf" value={this.state.formdetails.apppdf  || ''} onChange={this.hideComponent} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" >
                                <div className="col-md-6" >
                                    <input type="submit" className="btn btn-primary" value="Save" />
                                </div>
                            </div>
                            </form>
                            <h3 className="text-center">List Of Submission of Tender For Approval</h3>
                            <div className="col-md-12 table-responsive" >
                            <table className="table table-bordered">
                                <thead>
                                    <tr className="bg-gray">
                                        <th>Tender Notice No.</th>
                                        <th>No.of Agencies</th>
                                        <th>No.of Agencies PreQualified</th>
                                        <th>Bid Validity Date</th>
                                        <th>Approved By</th>
                                        <th>Date of Forwarding</th>
                                        <th>Proposed Agency</th>
                                        <th>Approval File</th>
                                        <th>Remarks</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.submitinvitiongtenderslist.map((value, index) => {
                                    return (
                                        <tr key={value.slno}>
                                            <td>{value.tendernoticeno}</td>
                                            <td>{value.totalagencies}</td>
                                            <td>{value.qualifiedagencies}</td>
                                            <td>{value.bidvaliditydate}</td>
                                            <td>{value.aastatusdesc}</td>
                                            <td>{value.dateofforwarding}</td>
                                            <td>{value.agencyname}</td>
                                            <td>{value.attace}</td>
                                            <td>{value.forwardedremark}</td>
                                            <td><button onClick={this.InvitingTendersDeleted.bind(this,value.slno)} className="btn btn-primary btn-sm"><i className="fa fa-trash"></i></button></td>
                                        </tr>
                                    )
                                })} 
                                </tbody>                                 
                            </table>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}

export default Invitingtenders
